<script setup lang="ts">
import PdsIcon from '@/components/pds/PdsIcon.vue';
import { RouterLink } from 'vue-router';

withDefaults(defineProps<{ to?: string; label?: string }>(), {
  to: '/',
  label: 'Tableau',
});
</script>

<template>
  <RouterLink
    :to="to"
    class="bg-creux text-encre flex h-12 shrink-0 items-center gap-[6px] rounded-[24px] pr-4 pl-[15px] text-[14px] leading-[1.4] font-semibold sm:pr-5"
  >
    <PdsIcon name="arrow-left" :size="20" :stroke="2" />
    <span class="max-sm:sr-only">{{ label }}</span>
  </RouterLink>
</template>
